// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hjJuT","back":"styles_back__7R57r","iconWrapper":"styles_iconWrapper__HRII4","icon":"styles_icon__Y1Qct"};